import { Component, Input } from '@angular/core';
import { Campaign } from '../../../woo_services.module/shared-types';
@Component({
  selector: 'admin-follow-up',
  template: `
    <div class="tabbable__panel panel-margin right section info clearfix">
      <div class="col-sm-12 padding-left-right--2x">
        <h2>Admin</h2>
      </div>
    </div>
    <div class="tabbable__body">
      <automatic-mms-gain-toggle></automatic-mms-gain-toggle>
      <agency-self-service-form [campaign]="campaign"></agency-self-service-form>
      <frequency-limit [campaign]="campaign"></frequency-limit>
    </div>
  `,
  standalone: false,
})
export class AdminFollowUp {
  @Input() campaign: Campaign;
}
